// src/constants/roles.js
export const RoleMapping = {
    1: 'admin',
    2: 'staff',
    3: 'groomer',
  };